<template>
  <div class="content-pages">
    <div class="page-header"><h2><span class="breadcrumb-level">内容运营</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">服务板块管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">内容管理</span></h2></div>

    <el-tabs v-model="activeTab" @tab-change="handleTabChange">
      <el-tab-pane label="平台规则" name="platform_rules" />
      <el-tab-pane label="用户协议" name="user_agreement" />
      <el-tab-pane label="联系我们" name="contact_us" />
      <el-tab-pane label="宠境服务介绍" name="pet_dog_service" />
      <el-tab-pane label="退改政策" name="refund_policy" />
      <el-tab-pane label="服务协议" name="service_agreement" />
    </el-tabs>

    <div v-loading="loading">
      <el-form :model="form" label-width="120px">
        <el-form-item label="标题">
          <el-input v-model="form.title" placeholder="页面标题" />
        </el-form-item>

        <el-form-item v-if="activeTab === 'contact_us'" label="联系电话">
          <el-input v-model="form.phone" placeholder="客服电话" />
        </el-form-item>

        <el-form-item label="内容">
          <RichTextEditor v-model="form.content" />
        </el-form-item>

        <el-form-item v-if="activeTab === 'contact_us'" label="二维码">
          <Upload v-model="form.qrcode_url" :max-count="1" tip="推荐尺寸 宽 320 × 高 320 px" />
        </el-form-item>

        <el-form-item label="状态">
          <el-switch v-model="form.status" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import RichTextEditor from '../../components/RichTextEditor.vue';
import * as contentApi from '../../api/contentManagement';
import Upload from '../../components/Upload.vue';

const activeTab = ref('platform_rules');
const loading = ref(false);
const saving = ref(false);

const form = reactive({
  title: '', content: '', phone: '', qrcode_url: '', status: true,
});



const fetchPage = async (type) => {
  loading.value = true;
  try {
    const res = await contentApi.getContentPage(type);
    const data = res.data || {};
    form.title = data.title || '';
    form.content = data.content || '';
    form.phone = data.phone || '';
    form.qrcode_url = data.qrcode_url || '';
    form.status = data.status !== false;
  } catch {
    // 如果未创建，使用默认值
    form.title = '';
    form.content = '';
    form.phone = '';
    form.qrcode_url = '';
    form.status = true;
  } finally {
    loading.value = false;
  }
};

const handleTabChange = (tab) => {
  fetchPage(tab);
};

const handleSave = async () => {
  saving.value = true;
  try {
    await contentApi.updateContentPage(activeTab.value, { ...form });
    ElMessage.success('保存成功');
  } catch {
    ElMessage.error('保存失败');
  } finally {
    saving.value = false;
  }
};

onMounted(() => fetchPage('platform_rules'));

</script>

<style scoped>
.upload-img { width: 200px; height: 120px; object-fit: cover; border-radius: 4px; }
.upload-icon { font-size: 28px; color: #8c939d; }
.avatar-uploader { border: 1px dashed #d9d9d9; border-radius: 6px; cursor: pointer; padding: 20px; text-align: center; display: inline-block; }
.avatar-uploader:hover { border-color: #409eff; }
</style>
